export function groupBy<T>(array: T[], keyGetter: (item: T) => string): Record<string, T[]> {
  return array.reduce(
    (result, currentItem) => {
      const key = keyGetter(currentItem);
      if (!result[key]) {
        result[key] = [];
      }
      result[key].push(currentItem);
      return result;
    },
    {} as Record<string, T[]>,
  );
}

export function getISOWeek(dateString: string): string {
  const date = new Date(dateString);
  const dayNum = date.getUTCDay() || 7;
  date.setUTCDate(date.getUTCDate() + 4 - dayNum);
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  return `${date.getUTCFullYear()}-W${weekNo.toString().padStart(2, '0')}`;
}

export function getMonth(dateString: string): string {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed in JS
  return `${year}-${month}`;
}
